(() => {
  const photos = {
    Black: ['dzbanek_czarny_6e2422bf-5c99-435f-9d2f-9f0937ed77bd.png?v=1790756802', 'dzbanek_czarny2.png?v=1790756802', 'dzbanek_czarny1.png?v=1790756803'],
    Gold: ['dzbanek_zloty_be47f5c7-58ff-4190-9758-c85755d14b05.png?v=1790756801', 'dzbanek_zloty2.png?v=1790756801', 'dzbanek_zloty1.png?v=1790756803']
  };
  let alignmentFrame;
  const alignCards = () => {
    cancelAnimationFrame(alignmentFrame);
    alignmentFrame = requestAnimationFrame(() => {
      document.querySelectorAll('.cc-barista .cc-two, .cc-barista .cc-three').forEach(grid => {
        const cards = [...grid.children].filter(card => card.matches('.cc-card'));
        cards.forEach(card => card.querySelectorAll('.cc-buy-summary, .cc-cardbody > .cc-textlink').forEach(el => el.style.removeProperty('margin-top')));
        if (window.innerWidth < 750) return;
        const rows = new Map();
        cards.forEach(card => {
          const y = Math.round(card.getBoundingClientRect().top);
          if (!rows.has(y)) rows.set(y, []);
          rows.get(y).push(card);
        });
        rows.forEach(row => {
          if (row.length < 2) return;
          ['.cc-buy-summary', '.cc-cardbody > .cc-textlink'].forEach(selector => {
            const items = row.map(card => card.querySelector(selector)).filter(Boolean);
            const positions = items.map(el => ({el, top:el.getBoundingClientRect().top, margin:parseFloat(getComputedStyle(el).marginTop) || 0}));
            const max = Math.max(...positions.map(item => item.top));
            positions.forEach(({el,top,margin}) => el.style.marginTop = `${margin + max - top}px`);
          });
        });
      });
    });
  };
  window.addEventListener('resize', alignCards, {passive:true});
  document.fonts?.ready.then(alignCards);
  const init = () => document.querySelectorAll('[data-barista-purchase]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form'), submit = form.querySelector('[type=submit]');
    const qty = form.querySelector('[name=quantity]'), status = form.querySelector('[data-buy-status]');
    const money = n => new Intl.NumberFormat(root.dataset.locale, {style:'currency', currency:root.dataset.currency || 'EUR'}).format(n / 100);
    function refresh() {
      const option = form.querySelector('[name=id]:checked');
      const valid = option.dataset.available === 'true';
      const q = Math.max(1, Math.min(99, parseInt(qty.value,10) || 1));
      form.querySelector('[data-buy-total]').textContent = money(Number(option.dataset.price) * q);
      form.querySelector('[data-pack-note]').hidden = option.dataset.packSize !== '3';
      form.querySelector('[data-buy-free]').hidden = option.dataset.free !== 'true';
      submit.disabled = !valid;
      submit.textContent = valid ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
      alignCards();
    }
    form.addEventListener('change', e => {
      if (e.target.name === 'barista-colour') {
        const colour = e.target;
        form.querySelector('[data-pack-size="1"]').value = colour.dataset.single;
        form.querySelector('[data-pack-size="3"]').value = colour.dataset.pack;
        form.querySelector('[data-pack-size="1"]').dataset.available = colour.dataset.singleAvailable;
        form.querySelector('[data-pack-size="3"]').dataset.available = colour.dataset.packAvailable;
        const container = root.closest('.cc-pdp') || root.closest('.cc-card');
        const base = 'https://cdn.shopify.com/s/files/1/0943/0882/7480/files/';
        const set = photos[colour.value];
        const main = container.querySelector('[data-gallery-main] img, .cc-media img');
        if (main) { main.src = base + set[0] + '&width=1200'; main.alt = 'Milk frothing jug — ' + colour.value; }
        container.querySelectorAll('[data-gallery-src]').forEach((button,i) => {
          button.dataset.gallerySrc = base + set[i] + '&width=1200';
          button.querySelector('img').src = base + set[i] + '&width=160';
          button.setAttribute('aria-pressed',i === 0 ? 'true' : 'false');
        });
        container.querySelectorAll('a[href*="view=cc-pitcher"]').forEach(a => { const url = new URL(a.href); url.searchParams.set('variant',colour.dataset.single); a.href=url; });
      }
      refresh();
    });
    qty.addEventListener('input',refresh);
    form.addEventListener('submit',async e => {
      e.preventDefault();
      if (submit.disabled || !form.reportValidity()) return;
      submit.disabled = true; submit.textContent = submit.dataset.addingLabel;
      status.textContent = ''; root.querySelector('[data-buy-next]').hidden = true;
      const option = form.querySelector('[name=id]:checked');
      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const payload = {items:[{id:Number(option.value),quantity:Number(qty.value)}]};
      if (cartUI?.getSectionsToRender) {
        payload.sections = cartUI.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
        cartUI.setActiveElement?.(submit);
      }
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        status.textContent = status.dataset.success;
        root.querySelector('[data-buy-next]').hidden = false;
        if (result.sections && cartUI?.renderContents) {
          try { cartUI.classList.remove('is-empty'); cartUI.renderContents(result); }
          catch (renderError) { console.warn('Cart display refresh failed', renderError); }
        }
        const cartResponse = await fetch((window.Shopify?.routes?.root || '/')+'cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span').forEach(n => { n.textContent=cart.item_count; });
        }
      } catch (error) { status.textContent = error.message || status.dataset.error; }
      finally { refresh(); }
    });
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
